import Contentful from 'contentful'
import { TypeItemFeatureHighlight } from './item-feature-highlight'

export enum SignUpFormMaskType {
  Edu = 'Edu',
  Generic = 'Generic',
}

export interface TypeComponentSignUpFormMaskFields {
  internalName: Contentful.EntryFields.Symbol
  type: SignUpFormMaskType
  heading: TypeItemFeatureHighlight
  emailPlaceholder: Contentful.EntryFields.Symbol
}

export type TypeComponentSignUpFormMask = Contentful.Entry<TypeComponentSignUpFormMaskFields>
